import React from "react";
import { Collapse, IconButton, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon } from "@mui/icons-material";
import DocumentsTable from "../DocumentsTable";
import CloudDownloadIcon from "../../../../icons/CloudDownloadIcon";

const DocTypeAccordion = ({ typeName, documents, sectionKey, onExportDocType, defaultOpen, highlightDocumentId }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(Boolean(defaultOpen));

  React.useEffect(() => {
    setOpen(Boolean(defaultOpen));
  }, [defaultOpen]);

  if (documents.length === 0) return null;

  return (
    <div>
      <div className={classes.trigger} onClick={() => setOpen(!open)}>
        {open ? <ExpandLessIcon className={classes.arrow} /> : <ExpandMoreIcon className={classes.arrow} />}
        <Typography className={classes.label}>{typeName}</Typography>
        <div className={classes.spacer} />
        <IconButton
          size="small"
          className={classes.downloadIcon}
          onClick={(e) => {
            e.stopPropagation();
            onExportDocType?.(sectionKey, typeName);
          }}
        >
          <CloudDownloadIcon />
        </IconButton>
      </div>
      <Collapse in={open}>
        <div className={classes.tableWrap}>
          <DocumentsTable documents={documents} sectionKey={sectionKey} highlightDocumentId={highlightDocumentId} />
        </div>
      </Collapse>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  trigger: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    padding: "0 16px",
    minHeight: 56,
    borderRadius: 8,
    backgroundColor: "#FAFAFA",
  },
  arrow: { color: "#71717A", marginRight: 8, fontSize: 20 },
  label: { fontSize: 14, color: "#71717A", fontWeight: 400 },
  spacer: { flex: 1 },
  downloadIcon: { color: "#A1A1AA" },
  tableWrap: { paddingLeft: 48, paddingTop: 12, paddingBottom: 4 },
}));

export default DocTypeAccordion;
